<template>
<div class="invoice">
    <div class="invoice__loading" v-if="isLoading">
      <adx-loading-primary/>
    </div>
    <div v-else>
      <!-- Header -->
      <div class="invoice__header">
        <img src="/img/adx/adx-red.png" alt="">
        <span @click="print" class="noprint">Print <img src="/img/adxicon/ic-print@2x.png" alt=""></span>
      </div>
      <!-- ADX Information -->
      <div class="invoice__adx-information">
        <div class="invoice__adx-information__content">
          <p class="title">PT. Narada Sahara Kencana</p>
          <div><span>80.351.501.4-047.000</span></div>
          <div><span>Muara Karang Block D 7 B No.46 Jakarta Utara - 14450</span></div>
          <div><span>P : 021 - 6614822</span></div>
          <div><span>F : 021 - 6610192</span></div>
          <div><span>E : support@adxasia.co.id</span></div>
          <div><span>www.adxasia.co.id</span></div>
        </div>
      </div>
      <!-- Title -->
      <div class="invoice__title">
        <p>Order ID : {{ orderNumber }}</p>
        <p>Order date : {{ orderDate }}</p>
      </div>
      <div class="invoice__payment">
        <!-- Amount to pay -->
        <div class="invoice__payment__amount">
          <p>Amount to pay :</p>
          <span>{{ net_price | formatMoney}}</span>
        </div>
        <div class="invoice__payment__table">
          <table>
            <tr>
              <td>
                <div class="invoice__payment__table__bank">
                  <img v-if="paymentBank == 'bca'" src="https://media.adxasia.co.id/emails/img-bca-logo%402x.png" alt="BCA" >
                  <img v-if="paymentBank == 'permata'" src="https://media.adxasia.co.id/emails/img-permata-logo%402x.png" alt="Permata" >
                  <img v-if="paymentBank == 'bni'" src="https://media.adxasia.co.id/emails/img-bni-logo%402x.png" alt="BNI" >
                  <img v-if="paymentBank == 'mandiri'" src="https://media.adxasia.co.id/emails/img-mandiri-logo%402x.png" alt="Mandiri" >
                </div>
              </td>
              <td> 
                <table>
                  <tr>
                    <td>
                      <div class="invoice__payment__table__info">
                        <div v-if="paymentBank == 'bca'">
                          <p class="invoice__payment__table__info__top">Pay using BCA Virtual Account</p>
                          <p class="invoice__payment__table__info__bot" >Transfer to BCA virtual account, and input our virtual account code</p>
                        </div>
                        <div v-if="paymentBank == 'permata'">
                          <p class="invoice__payment__table__info__top">Pay using Permata Virtual Account</p>
                          <p class="invoice__payment__table__info__bot" >Transfer to Permata virtual account, and input our virtual account code</p>
                        </div>
                        <div v-if="paymentBank == 'bni'">
                          <p class="invoice__payment__table__info__top">Pay using BNI Virtual Account</p>
                          <p class="invoice__payment__table__info__bot" >Transfer to BNI virtual account, and input our virtual account code</p>
                        </div>
                        <div v-if="paymentBank == 'mandiri'">
                          <p class="invoice__payment__table__info__top">Pay using Mandiri Virtual Account</p>
                          <p class="invoice__payment__table__info__bot" >Transfer to Mandirivirtual account, and input our virtual account code</p>
                        </div>
                        <p class="invoice__payment__table__info__va" style="font-size: 15px; font-weight: bold; margin: 0">{{vaNumber}}</p>
                      </div>
                      
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <!-- Payment Status -->
        <div class="invoice__payment__status">
          <div v-if="paymentStatus != 'paid'" class="invoice__payment__status__content">
            <p>Payment status :</p>
            <p class="waiting">Waiting For Payment</p>
            <p v-if="paymentDate" >Please complete this payment before due date on :</p>
            <p v-if="paymentDate" class="date">{{ paymentDate }} WIB</p>
          </div>
          <div v-else class="invoice__payment__status__content">
            <p>Payment status :</p>
            <p class="paid">Paid</p>
          </div>
        </div>
      </div>
      <!-- User Information -->
      <div class="invoice__information">
        <div class="invoice__information__content">
          <p class="title">Bill to :</p>
          <div>
            <span><p>Name</p></span>
            <span><p>{{ user.name }}</p></span>
          </div>
          <div>
            <span><p>Phone</p></span>
            <span><p>{{ user.phone }}</p></span>
          </div>
          <div>
            <span><p>Email</p></span>
            <span><p>{{ user.email }}</p></span>
          </div>
          <div>
            <span><p>Address</p></span>
            <span><p>{{ user.address }}</p></span>
          </div>
        </div>
      </div>
      <!-- Invoice Detail -->
      <div class="invoice__detail">
        <div class="invoice__detail__title"><p>Invoice Summary :</p></div>
        <table>
          <thead>
            <tr>
              <td v-for="(header, index) in headers" :key="index">{{ header }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in campaigns" :key="index" class="items">
              <td>
                <div class="name">{{ item.name }}</div>
                <div class="detail">{{ item.detail }}</div>
              </td>
              <td>
                <div class="price">{{ item.price | formatMoney }}</div>
              </td>
            </tr>
            <tr class="subHeader">
              <td >Sub Total</td>
              <td class="price">{{ subTotal | formatMoney}}</td>
            </tr>
            <tr v-if="discount > 0" class="items">
              <td>
                <div class="name">Discount</div>
              </td>
              <td>
                <div class="price"><span>- </span> {{ discount | formatMoney }}</div>
              </td>
            </tr>
            <tr v-if="balance > 0" class="items">
              <td>
                <div class="name">ADX Balance</div>
              </td>
              <td>
                <div class="price"><span>- </span> {{ balance | formatMoney }}</div>
              </td>
            </tr>
            <tr class="subHeader">
              <td >Total Price</td>
              <td class="price">{{ net_price | formatMoney}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { calculateTax } from '@/lib/util'

export default {
  name: 'adx-',
  components: {
    'adx-loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      orderNumber: '',
      orderDate: '',
      paymentStatus: 'pending',
      paymentDate: '',
      paymentMethod: '',
      paymentBank: '',
      vaNumber: '',
      user: {
        name: '',
        phone: '',
        email: '',
        address: ''
      },
      campaigns: [],
      headers: [
        'Campaign Name',
        'Price'
      ],
      invoiceId: '',
      balance: 0,
      discount: 0,
      tax: 0,
      net_price: 0,
      price: 0,
    }
  },
  computed: {
    subTotal: function () {
      return this.net_price + this.balance + this.discount
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { order_id } = this.$route.params
    if (order_id) {
      this.orderId = order_id
      this.loadData()
    } else {
      this.$router.replace({ name: '404' })
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      (async () => {
        this.isLoading = true
        const response = await api.get(apiV2.invoicOrderDetail(this.orderId), { needToken: true })
        if (response.status === 200) {
          const { data } = response
          this.mapData(data)
          this.isLoading = false
        } else {
          if (response.status == 403) {
            this.$router.replace({ name: '403' })
          }
        }
      })();
    },
    mapData(data) {
      this.tax = data.tax_price
      this.orderNumber = data.number
      this.orderDate = data.created
      this.net_price = data.net_price
      this.paymentStatus = data.status
      this.paymentDate = data.due_date
      this.paymentMethod = data.payment_method,
      this.vaNumber = data.va_number,
      this.paymentBank = data.bank,
      this.user = {
        name: data.user.full_name,
        phone: data.user.phone || '',
        email: data.user.email || '',
        address: data.user.address || ''
      }
      this.balance = data.total_balance
      this.discount = data.total_discount
      data.campaigns.map(campaign => {
        this.campaigns.push({
          name: campaign.title,
          price: campaign.before_tax_price,
          detail: campaign.invoice_number
        })
      })
      this.campaigns.push({
        name: 'PPN 10%',
        price: this.tax,
        detail: ''
      })
    },
    print() {
      window.print()
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>